import React from 'react';
import PropTypes from 'prop-types';
import { $, add } from 'moneysafe';

import { APP_CURRENCY_NAME } from 'config/constants';

import sampleImg from 'assets/images/noImg.png';

import style from './CartItems.module.scss';

CartItems.propTypes = {
    products: PropTypes.array.isRequired
};

function CartItems({ products }) {
    const getTotal = () => {
        let price = 0;

        for (const product of products) {
            price = $(product.selectedRentalPeriod.price) + price;

            if (product.selectedStorage && product.selectedStorage.item.price_impact) {
                const find = product.selectedStorage.item.price_impacts.find(e => e.rental_period_id === product.selectedRentalPeriod.id);

                if (find) {
                    price = add($(price), $(find.price_impacts));
                }
            }

            if (product.selectedDeals && product.selectedDeals.discount_amount) {
                price = Math.ceil($(price) - $(product.selectedDeals.discount_amount)).toFixed(0);
            }
        }

        return (APP_CURRENCY_NAME) + ' ' + price.toString();
    };

    const getImageBasedColor = (images, colorID) => {
        const findColor = images.find(e => e.id === colorID);

        if (findColor) {
            const check = findColor.images.find(e => e.primary === true);

            if (check) {
                return check.url;
            }

            return findColor?.images?.images[0]?.url;
        }

        return sampleImg;
    };

    return (<div className={style.section}>
        <div className={style.sideProducts}>
            {products.map((product, i) =>
                <div key={i} className={style.product}>
                    <img src={product.images.length !== 0 ? getImageBasedColor(product.images, product?.selectedColor?.value) : sampleImg} alt={product.name} className={style.product__img}/>
                </div>
            )}
        </div>
        <div className={style.sideInfo}>
            <div className={style.sideInfo__title}>Monthly rent</div>
            <div className={style.sideInfo__price}>{getTotal()} / Month</div>
        </div>
    </div>);
}

export default CartItems;
